'use strict';

require('./vendor');
require('./viewport');

$(window).on('load resize scroll', function(e) {
	// Fade in elements when in viewport
	$('.column, .columns, .effect').each(function(i, element) {
		var $a = $(element);
		if ($a.visible(true)) {
			$a.addClass('in-viewport');
		}
	});
});

$(document).ready(function() {
	$('.menu-button').click(function() {
		$('body').toggleClass('menu-open');
	});

	function scrolled() {
		if ($(document).scrollTop() > 0) {
			$('body').addClass('scrolled');
		} else {
			$('body').removeClass('scrolled');
		}
	}

	function scrollToAnchor(element) {
		$(element).click(function(e) {
			e.preventDefault();
			$('html, body').animate({scrollTop: $($(this).attr('href')).offset().top - 75 }, 500);
		});
	}

	if ($('.sticker-wrapper').length) {
		var stickers = $('.sticker-wrapper .sticker').length;

		if (stickers == 1) {
			$('.sticker-wrapper').addClass('one');
		}
	}

	$('.slider-nav a').click(function(e) {
		e.preventDefault();
	});

	$('.open-search').click(function(e) {
		e.preventDefault();

		$('.search-wrapper').addClass('active');
	});

	$('.close-search').click(function(e) {
		e.preventDefault();

		$('.search-wrapper').removeClass('active');
	});

	// Faq
	$('.faq-question h5, .faq-icon').click(function(e) {
		e.preventDefault();
		$('.faq-extended').stop();

		var parent = $(this).closest('.faq-item');

		if (parent.hasClass('active')) {
			parent.find('.faq-extended').slideUp(300);
			parent.removeClass('active').addClass('slide-up');
			setTimeout(function() {
				parent.removeClass('slide-up');
			}, 300);
		} else {
			$('.faq-extended').slideUp(300);
			$('.faq-item').removeClass('active');
			parent.find('.faq-extended').slideDown(300);
			parent.addClass('active');
		}
	});

	// Initial load
	$('.faq-extended').slideUp(300);
	$('.faq-item').removeClass('active');

	// Vertical slider
	var timer;

	function verticalSlider(element, elementType, target) {
		var firstElement = $(element + ' ' + elementType).eq(0);
		var currentElement = $(element + ' ' + elementType + '.active');
		var nextElement = currentElement.next(elementType);

		if (nextElement.length == 0) {
			firstElement.addClass('active');
		}

		if (target) {
			$(element + ' ' + elementType).removeClass('active');
			$(element + ' ' + elementType + '[data-slider-id="' + target + '"]').addClass('active');
		} else {
			currentElement.removeClass('active');
			nextElement.addClass('active');
		}
	}

	// Init slider
	timer = setInterval(function() {
		verticalSlider('.slider', 'div');
		verticalSlider('.slider-nav', 'li');
		verticalSlider('.slider-descriptions', 'div');
	}, 5000);

	// On hover clear the sliders' interval
	$('.slider, .slider-descriptions').hover(function() {
		clearInterval(timer);
	}, function() {
		timer = setInterval(function() {
			verticalSlider('.slider', 'div');
			verticalSlider('.slider-nav', 'li');
			verticalSlider('.slider-descriptions', 'div');
		}, 5000);
	});

	// Go to slide
	$('.slider-nav a').click(function(e) {
		e.preventDefault();

		clearInterval(timer);

		var slider_id = $(this).parent('li').data('slider-id');

		verticalSlider('.slider', 'div', slider_id);
		verticalSlider('.slider-nav', 'li', slider_id);
		verticalSlider('.slider-descriptions', 'div', slider_id);
	});

	// Remove menu open class
	function removeMenuOpenClass() {
		if ($(window).width() > 1024) {
			$('body').removeClass('menu-open');
		}
	}

	$('.header-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 1000,
		arrows: false,
		fade: true
	});

	// Init
	scrollToAnchor('.more-info');
	removeMenuOpenClass();

	// Scroll
	$(window).scroll(function() {
		scrolled();
	});

	// Resize
	$(window).resize(function() {
		removeMenuOpenClass();
	});

	$(document).foundation();
});

if (module.hot) {
	module.hot.accept()
}
